<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import Auth from 'dashboard/api/auth';
import { useAccount } from 'dashboard/composables/useAccount';

const iframeSrc = ref('');
const store = useStore();
const { accountId } = useAccount();

const DEFAULT_CRM_URL = 'https://manager.sync2b.com';

async function getCrmBaseUrl() {
  // Tenta da store primeiro (já carregada)
  const cached = store.getters['accounts/getAccount'](accountId.value);
  if (cached?.custom_attributes?.crm_url)
    return cached.custom_attributes.crm_url;

  // Busca via API para garantir dado atualizado
  try {
    await store.dispatch('accounts/get', accountId.value);
    const account = store.getters['accounts/getAccount'](accountId.value);
    return account?.custom_attributes?.crm_url || DEFAULT_CRM_URL;
  } catch {
    return DEFAULT_CRM_URL;
  }
}

onMounted(async () => {
  try {
    const auth = Auth.getAuthData();
    if (!auth || !auth['access-token']) throw new Error('no auth data');

    const [tokenRes, base] = await Promise.all([
      fetch('/api/v1/sso/manager_token', {
        headers: {
          'access-token': auth['access-token'],
          'token-type': auth['token-type'],
          client: auth.client,
          uid: auth.uid,
          expiry: auth.expiry,
        },
      }),
      getCrmBaseUrl(),
    ]);

    if (!tokenRes.ok) throw new Error(`http ${tokenRes.status}`);
    const { token } = await tokenRes.json();
    const url = new URL(base);
    url.searchParams.set('sso_token', token);
    iframeSrc.value = url.toString();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[SSO]', e.message);
    const base = await getCrmBaseUrl();
    iframeSrc.value = base;
  }
});
</script>

<template>
  <div class="crm-wrapper">
    <iframe
      v-if="iframeSrc"
      :src="iframeSrc"
      class="crm-frame"
      :title="$t('SIDEBAR.CRM')"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>

<style scoped>
.crm-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.crm-frame {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
